import { PtLuxonDate } from '../projects/date.models';

export class ConsumableEditor {


  constructor() {
    this.usedPotableWater = 0;
    this.usedFuelOil = 0;
    this.usedLubeOil = 0;
    this.usedUrea = 0;
    this.usedJackingGrease = 0;

    this.previousDay = new PreviousDayTotal();
  }

  id: number | null;

  date: PtLuxonDate;

  isCompleted: boolean;

  loadedFuelOil: number | null;

  fuelOilDensity: number | null;

  transferredFuelOil: number | null;

  usedFuelOil: number;

  adjustRemainingOnBoardFuelOilTotal: number | null;

  reasonForAdjustmentFuelOil: string;

  loadedPotableWater: number | null;

  madePotableWater: number | null;

  usedPotableWater: number;

  adjustRemainingOnBoardPotableWaterTotal: number | null;

  reasonForAdjustmentPotableWater: string;

  loadedLubeOil: number | null;

  transferredLubeOil: number | null;

  usedLubeOil: number;

  adjustRemainingOnBoardLubeOilTotal: number | null;

  reasonForAdjustmentLubeOil: string;

  loadedUrea: number | null;

  usedUrea: number | null;

  adjustRemainingOnBoardUreaTotal: number | null;

  reasonForAdjustmentUrea: string;

  loadedJackingGrease: number | null;

  usedJackingGrease: number;

  adjustRemainingOnBoardJackingGreaseTotal: number | null;

  reasonForAdjustmentJackingGrease: string;

  sludge: number | null;

  recyclables: number | null;

  garbage: number | null;

  foodWasteType: string | null;

  foodWaste: number | null;

  tracksUreaUsage: boolean;
  
  previousDay: PreviousDayTotal;  
}

export class PreviousDayTotal {

  constructor() {
    this.previousFuelOil = 0;
    this.previousLubeOil = 0;
    this.previousPotableWater = 0;
    this.previousUrea = 0;
    this.previousJackingGrease = 0;
  }

  previousFuelOil: number;

  previousLubeOil: number;

  previousPotableWater: number;

  previousUrea: number;

  previousJackingGrease: number;
}



// WEBPACK FOOTER //
// ./src/models/consumables/consumables.models.ts